module.exports = __webpack_public_path__ + "img/icon_sort_asc.674f301e.svg";